var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"iconfont icon-jiazai loading",style:('color:'+_vm.color)}),_c('div',{staticClass:"text",style:('color:'+_vm.color)},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }